import React, { useState, useCallback } from 'react'
import '../css/TopBar.css';
import { ReactComponent as LogoTexto6B } from '../assets/svg/6blogo.svg';
import { useNavigate } from "react-router-dom";
import { ReactComponent as Volver } from '../assets/icon/volver.svg';
import { getTarjetaByNumero } from '../services/tarjetas';

function TopBar() {
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    const handleLogout = () => {
        navigate("/");
    };

    const handleSearch = useCallback(async (e) => {
        const value = e.target.value;
        setSearchValue(value);
    }, []);

    const handleKeyDown = useCallback(async (e) => {
        if (e.key === 'Enter' || e.key === 'Tab') {
            e.preventDefault();
            const value = e.target.value;

            if (value.length >= 4) {
                const cleanedValue = value.replace(/\s/g, '');

                if (/^\d+$/.test(cleanedValue)) {
                    setIsSearching(true);
                    try {
                        const result = await getTarjetaByNumero(cleanedValue);
                        if (result.success && result.data && result.data.error === 0 && result.data.data) {
                            const tarjetaData = Array.isArray(result.data.data) ? result.data.data : [result.data.data];
                            localStorage.setItem('tarjetaSearchResult', JSON.stringify(tarjetaData));
                            localStorage.setItem('tarjetaSearchTerm', cleanedValue);
                            navigate('/dashboard/tarjetas');
                        } else {
                            localStorage.setItem('tarjetaSearchResult', JSON.stringify([]));
                            localStorage.setItem('tarjetaSearchTerm', cleanedValue);
                            navigate('/dashboard/tarjetas');
                        }
                    } catch (error) {
                        console.error('Error buscando tarjeta:', error);
                        localStorage.setItem('tarjetaSearchResult', JSON.stringify([]));
                        localStorage.setItem('tarjetaSearchTerm', cleanedValue);
                        navigate('/dashboard/tarjetas');
                    } finally {
                        setIsSearching(false);
                        setSearchValue('');
                    }
                }
            }
        }
    }, [navigate]);

    return (
        <div className='CuerpoTopbar'>
            <div className="iconos">
                <div className="svgMenu"><LogoTexto6B className="logo-svgmenu" /></div>
            </div>

            {/* BOTÓN LOGOUT */}
            <div className="logout-container">
                <button
                    className="logout-button"
                    onClick={handleLogout}
                    title="Cerrar sesión"
                >
                    <Volver className="logout-icon" />
                    <span className="logout-text">Salir</span>
                </button>
            </div>

        </div>
    )
}

export default TopBar
